// js/Api/contact_invite.js
//
// POC: QR/link "add contacts" flow.
// Endpoints live at ${REACT_APP_API_ORIGIN}/contact-invite (NOT under /portal).
// GET/POST {token} are public (token-authorised). generate is admin.

const BASE = `${process.env.REACT_APP_API_ORIGIN}/contact-invite`;

/** [Admin] Generate an invite token for an organisation's contact pool. */
export const generateContactInvite = async (orgId, days = 7) => {
    if (!orgId) return { success: false, error: "Organisation ID is required" };
    try {
        const res = await fetch(`${BASE}/generate/${orgId}?days=${days}`, {
            method: "POST",
            credentials: "include",
        });
        if (!res.ok) {
            return { success: false, error: "Failed to generate link", status: res.status };
        }
        const data = await res.json();
        return { success: true, data };
    } catch (e) {
        return { success: false, error: e.message };
    }
};

/** [Public] Validate a token, get the invite context (org name). */
export const getContactInviteContext = async (token) => {
    if (!token) return { success: false, error: "Token is required" };
    try {
        const res = await fetch(`${BASE}/${encodeURIComponent(token)}`, {
            method: "GET",
        });
        const data = await res.json().catch(() => null);
        if (!res.ok || !data?.valid) {
            return { success: false, error: "This link is invalid or has expired." };
        }
        return { success: true, data };
    } catch (e) {
        return { success: false, error: e.message };
    }
};

/** [Public] Submit contacts into the org's default contact pool. */
export const submitContactInvite = async (token, contacts) => {
    if (!token) return { success: false, error: "Token is required" };
    if (!Array.isArray(contacts) || contacts.length === 0) {
        return { success: false, error: "Add at least one contact." };
    }
    try {
        const res = await fetch(`${BASE}/${encodeURIComponent(token)}`, {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ contacts }),
        });
        const data = await res.json().catch(() => null);
        if (!res.ok) {
            return {
                success: false,
                error: (data && (data.error || data.message)) || "Failed to submit contacts.",
            };
        }
        return { success: true, data };
    } catch (e) {
        return { success: false, error: e.message };
    }
};
